import { environment } from 'app/config/environment';
import Dexie from 'dexie';
class LocalDataDatabase extends Dexie {
  constructor() {
    super(environment.LOCAL_PERSISTER_KEY);
    this.version(1).stores({
      issueImageUploads: 'id,issueId'
    });
    this.version(2).stores({
      issues: 'id,projectId'
    });
    this.version(3).stores({
      locale: 'id'
    });
  }
}
const db = new LocalDataDatabase();
export const clearLocalDatabase = async () => {
  const preserveTables = ['region'];
  const tablesToClear = db.tables.filter(table => !preserveTables.includes(table.name));
  await Promise.all(tablesToClear.map(table => table.clear()));
};
export default db;